import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { cityCardMotion } from './motion';
import { cityChromeTone } from './palette';

export const cityTheme: FlowThemeDefinition = {
  id: 'city',
  label: 'City Lights',
  description: 'A skyline lights up district by district from sunset to night, ending in fireworks over the bay.',
  category: 'night',
  chromeTone: cityChromeTone,
  swatch: 'linear-gradient(165deg, #2E3A78 0%, #8F4C8C 38%, #EE765E 62%, #0C1234 100%)',
  cardGlass: 'dense',
  cardMotion: cityCardMotion,
  burstSize: 300,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createCityScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
